import get from 'lodash/get';
import * as Api from '../api';
import * as Mappers from '../mappers';
import * as Types from '../types';

interface IProps {
  id: string;
}

const Single = ({ id }: IProps): [string[], () => Promise<Types.IQuery.Single>] => [
  ['test', 'single', id],
  async () => {
    const { data } = await Api.Single({ id });

    // Backend may return either `{ data: {...} }` or the raw object.
    const raw = get(data, 'data') ?? data;
    const item = Mappers.TestDetails(raw);

    return {
      item,
    };
  },
];

export default Single;
